import React, { Fragment as _, FC } from 'react';
import { Box } from 'theme-ui';

interface ISubmitContinue {
  selected: string[];
  location: string;
  navigateToResults: boolean;
  onSubmit: () => void;
  children;
}

const SubmitContinue: FC<ISubmitContinue> = props => {
  const { selected, location, navigateToResults, onSubmit, children } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '20px 0',
        //

        transition: 'opacity 0.2s',
        visibility:
          window.dev && window.dev()
            ? 'visible'
            : !selected.length
            ? 'hidden'
            : 'visible',
      }}
    >
      <Box
        sx={{
          cursor: 'pointer',
        }}
        onClick={(e: React.MouseEvent) => {
          if (window.dev && window.dev()) {
            return;
          }

          navigateToResults ? requestAnimationFrame(onSubmit) : onSubmit();
        }}
      >
        <Box
          sx={{
            'div [class*="NavigationButton"]': {
              top: '-10px',
              height: 'calc(100% + 20px)',
            },
          }}
        >
          {React.cloneElement(children, {
            location: navigateToResults ? location : 'next',
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default SubmitContinue;
